<template>
    <div class="reset-password-container">
        <img alt="Logo Delicorner" class="logo" src="/svg/logo--white.svg"/>

        <form class="reset-password-box">
            <p class="reset-password-message">
                Veuillez saisir votre nouveau mot de passe.
            </p>
            <div class="mb-2">
                <label class="block text-gray-700 text-sm font-bold mb-2"
                       for="password"></label>
                <input id="password"
                       autofocus
                       v-model="password"
                       required
                       class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                       placeholder="Mot de passe"
                       type="password"
                />
                <label class="block text-gray-700 text-sm font-bold mb-2"
                       for="confirm-password"></label>
                <input id="confirm-password"
                       v-model="confirmPassword"
                       required
                       class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                       placeholder="Répétez votre mot de passe"
                       type="password"
                />
            </div>
            <p class="mb-4 reset-password-message reset-password-requirements">
              Le mot de passe doit comporter au moins 8 caractères, incluant au moins une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial parmi @, $, !, %, *, ?, et &
            </p>
            <div class="flex items-center justify-center">
                <button class="reset-password-button" @click.prevent="submit">
                    <img alt="" class="buttonImg" src="/svg/lemon.svg"/>
                    <span class="textButton">GO!</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import {notifyRaw} from "@/helper";
import {api, API_ROUTES} from "@/Services/api.common.service";

export default {
    name: "ResetPassword",
    data() {
        return {
            password: "",
            confirmPassword: ""
        };
    },
    methods: {
        submit() {
            const self = this;
            const notify = notifyRaw.bind(this);
            if (this.password === "") {
                notify("Veuillez saisir un mot de passe", "error");
                return;
            }
            if (this.password !== this.confirmPassword) {
                notify("Les mots de passe ne correspondent pas", "error");
                return;
            }
            api().post(API_ROUTES.auth.resetPassword, {
                password: this.password,
                token: this.$route.query.token
            })
                .then(function () {
                    notify(
                        `Votre mot de passe a bien été réinitialisé !<br>Vous allez être redirigé vers la page de connexion`,
                        "success"
                    );
                    setTimeout(() => {
                        self.$router.push({name: "login"});
                    }, 2000);
                })
                .catch(function (error) {
                    if (error.response) {
                        notify(error.response.data.error.message, "error");
                    }
                });
        }
    }
}
</script>

<style lang="css" scoped>
.reset-password-button {
    cursor: pointer;
    position: relative;
}

.textButton {
    color: white;
    font-size: 24px;
    font-weight: bold;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-56%, -20%);
}

.logo {
    height: 100%;
    margin-bottom: 50px;
    max-height: 250px;
}

.reset-password-box {
    max-width: 400px;
    width: 50%;
}

input {
    background: white;
    font-size: 20px;
    line-height: 30px;
}

.reset-password-message {
    text-align: center;
    font-weight: 500;
    color: white;
    font-size: 1.1rem;
}

.reset-password-requirements {
  font-style: italic;
  font-size: 0.9rem;
}

.reset-password-container {
    @apply mx-auto flex flex-col justify-center items-center h-screen bg-main;
    width: 100%;
}
</style>
